// extracted by mini-css-extract-plugin
export default {"container":"signin_container__82XSo","topBox":"signin_topBox__nbFM0","bottomBox":"signin_bottomBox__HG4ad"};